import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Stripe, StripeElements } from '@stripe/stripe-js'

import chargeModel, { ChargeState } from '@/core/models/charge.model'

import { RootState } from '@/redux/rootReducer'

export type ChargeReducerState = ChargeState
export type AcceptPaymentActionPayload = {
  consultationId: string
  elements: StripeElements
  stripe: Stripe
}

export const selectChargeAcceptPaymentRequestTracker = (state: RootState) => state.charge.requestTracker.acceptPayment

export const setPriceRequestTracker = (state: RootState) => state.charge.requestTracker.setPrice

const initialState: ChargeReducerState = {
  ...chargeModel.getInitialState()
}

const chargeSlice = createSlice({
  name: chargeModel.reducerName,
  initialState,
  reducers: {
    acceptPayment(state, action: PayloadAction<AcceptPaymentActionPayload>) {
      state.requestTracker.acceptPayment.loading = true
    },
    acceptPaymentSuccess(state) {
      state.requestTracker.acceptPayment.error = null
      state.requestTracker.acceptPayment.loading = false
    },
    acceptPaymentFailure(state, action) {
      state.requestTracker.acceptPayment.error = action.payload
      state.requestTracker.acceptPayment.loading = false
    },
    acceptPaymentFromUserID(state, action: PayloadAction<AcceptPaymentActionPayload & { receiverID: string }>) {
      state.requestTracker.acceptPayment.loading = true
    },
    openStellair(state, action: PayloadAction<{ consultationId: string }>) {
      state.requestTracker.acceptPayment.loading = true
    }
  }
})

export const {
  acceptPayment,
  acceptPaymentSuccess,
  acceptPaymentFailure,
  openStellair,
  acceptPaymentFromUserID
} = chargeSlice.actions

export default chargeSlice.reducer